<template>
  <div class="card mb-4" id="headings">
    <div class="card-header">
      <h3>Headings</h3>
    </div>
    <div class="card-body">
      <h1>h1. Titolo 1</h1>
      <h2>h2. Titolo 2</h2>
      <h3>h3. Titolo 3</h3>
      <h4>h4. Titolo 4</h4>
      <h5>h5. Titolo 5</h5>
      <h6>h6. Titolo 6</h6>
    </div>
    <div class="card-header">
      <h3>Text</h3>
    </div>
    <div class="card-body">
      <p>
        Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod
        tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim
        veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea
        commodo consequat. Duis aute irure dolor in reprehenderit in voluptate
        velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint
        occaecat cupidatat non proident, sunt in culpa qui officia deserunt
        mollit anim id est laborum.
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: "Headings",
};
</script>
